import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=367bcff0&scoped=true"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=367bcff0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367bcff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367bcff0')) {
      api.createRecord('367bcff0', component.options)
    } else {
      api.reload('367bcff0', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=367bcff0&scoped=true", function () {
      api.rerender('367bcff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/panelManage/addModal.vue"
export default component.exports